"use client";

import {
  BaseFormRootError,
  type BaseFormRootErrorProps,
} from "./form-root-error";

export interface ConEdisonFormRootErrorProps extends BaseFormRootErrorProps {
  className?: string;
}

export type FormRootErrorFocusEvent = Parameters<
  Exclude<ConEdisonFormRootErrorProps["onFocus"], undefined>
>[0];

export default function ConEdisonFormRootError({
  className,
  variant,
  ...props
}: ConEdisonFormRootErrorProps) {
  return (
    <BaseFormRootError
      {...props}
      cardHeaderClassname="bg-website-gray"
      className="absolute top-2.5 w-full @[16rem]/form-item:min-w-fit min-w-[150%] @[16rem]/form-item:translate-x-0 translate-x-[-16.5%] text-center font-semibold text-destructive text-sm leading-[1.135]"
    />
  );
}
